(function() {
  angular.module('cfn').factory('PlantProtectant', PlantProtectant);
  PlantProtectant.$inject = ['dataSource.factory'];

  function PlantProtectant(dataSource) {
    return dataSource('plantProtectant').getRestService();
  }
})();
